import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    employeePersonals: [],
    employeePersonalsCount: 0,
    employeePersonal: {},
    employeePersonalSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getEmployeePersonals(state) {
      return state.employeePersonals
    },
    getEmployeePersonalsCount(state) {
      return state.employeePersonalsCount
    },
    getEmployeePersonal(state) {
      return state.employeePersonal
    },
    getEmployeePersonalSaveStatus(state) {
      return state.employeePersonalSave
    },
  },
  mutations: {
    EMPLOYEE_PERSONALS_LIST(state, data) {
      state.employeePersonals = data
    },
    EMPLOYEE_PERSONAL_VIEW(state, data) {
      state.employeePersonal = data
    },
    EMPLOYEE_PERSONALS_COUNT(state, data) {
      state.employeePersonalsCount = data
    },
    EMPLOYEE_PERSONAL_SAVE(state, data) {
      state.employeePersonalSave = data
    },
  },
  actions: {
    employeePersonalsList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/hr/employee_personal', data)
        .then(response => {
          commit('EMPLOYEE_PERSONALS_LIST', response.data.data)
          commit('EMPLOYEE_PERSONALS_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    employeePersonalView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'employee_personal.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/hr/employee_personal', data)
        .then(response => {
          commit('EMPLOYEE_PERSONAL_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    employeePersonalSave({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post('/hr/employee_personal/saveData', data)
        .then(response => {
          commit('EMPLOYEE_PERSONAL_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
